import api from './api'
import type {
  Conversation,
  ConversationListResponse,
  ConversationDetailResponse,
  SendMessageResponse,
  Message,
} from '@/schemas/chat'

export const chatService = {
  async createConversation(
    projectId: string,
    data: { agent_id: string; title?: string }
  ): Promise<Conversation> {
    const response = await api.post<Conversation>(
      `/projects/${projectId}/conversations`,
      data
    )
    return response.data
  },

  async listConversations(
    projectId: string,
    params?: { page?: number; page_size?: number }
  ): Promise<ConversationListResponse> {
    const response = await api.get<ConversationListResponse>(
      `/projects/${projectId}/conversations`,
      { params }
    )
    return response.data
  },

  async getConversation(
    projectId: string,
    conversationId: string
  ): Promise<ConversationDetailResponse> {
    const response = await api.get<ConversationDetailResponse>(
      `/projects/${projectId}/conversations/${conversationId}`
    )
    return response.data
  },

  async deleteConversation(
    projectId: string,
    conversationId: string
  ): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(
      `/projects/${projectId}/conversations/${conversationId}`
    )
    return response.data
  },

  async sendMessage(
    projectId: string,
    conversationId: string,
    data: { content: string }
  ): Promise<SendMessageResponse> {
    const response = await api.post<SendMessageResponse>(
      `/projects/${projectId}/conversations/${conversationId}/messages`,
      data
    )
    return response.data
  },

  async getMessages(
    projectId: string,
    conversationId: string,
    params?: { page?: number; page_size?: number }
  ): Promise<{ messages: Message[]; total: number; page: number; page_size: number; total_pages: number }> {
    const response = await api.get(
      `/projects/${projectId}/conversations/${conversationId}/messages`,
      { params }
    )
    return response.data
  },
}
